import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 36 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ type: "spring", damping: 25, stiffness: 120, delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
